import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "./CommonViews";
export const CommonProjectImportExportHelp = ({ children }: {
    children: React.ReactNode;
}) => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                Projects can be exported and imported into a new space. Please read the <ExternalLink href="ProjectExportImport">docs</ExternalLink> before beginning, to ensure all factors have been considered.
            </p>
            {children}
        </OverviewHighlightText>
    </OverviewContainer>);
export const CommonProjectImportExportTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="ProjectExportImport">Exporting and Importing Projects</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
